import React, { useState, useEffect } from 'react';

interface DynamicLoaderProps {
  messages: string[];
  intervalMs?: number;
  color?: string;
  size?: 'small' | 'large';
}

export const DynamicLoader: React.FC<DynamicLoaderProps> = ({
  messages,
  intervalMs = 2500,
  color = '#3182CE',
  size = 'large',
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (messages.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [messages, intervalMs]);

  const spinnerSize = size === 'large' ? 40 : 24;
  const borderWidth = size === 'large' ? 4 : 3;

  return (
    <div className="flex flex-col items-center justify-center py-5">
      <div
        className="rounded-full animate-spin"
        style={{
          width: spinnerSize,
          height: spinnerSize,
          border: `${borderWidth}px solid ${color}22`,
          borderTopColor: color,
        }}
      />
      <p className="mt-4 text-[15px] font-medium text-slate-500 text-center">
        {messages[currentIndex]}
      </p>
    </div>
  );
};
